var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-input",
      class: [
        "field-input--" + _vm.field.type.toLowerCase(),
        { "is-invalid": !!_vm.error }
      ],
      attrs: { title: _vm.error || _vm.field.label }
    },
    [
      _vm.isCheckbox
        ? _c("input", {
            staticClass: "field-input__checkbox",
            attrs: { type: "checkbox" },
            domProps: { checked: !!_vm.value },
            on: {
              change: function($event) {
                return _vm.$emit("input", $event.target.checked)
              }
            }
          })
        : _vm.isTextarea
        ? _c("textarea", {
            staticClass: "field-input__control field-input__textarea",
            style: _vm.controlStyle,
            attrs: { placeholder: _vm.field.placeholder || _vm.field.label },
            domProps: { value: _vm.value == null ? "" : _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event.target.value)
              }
            }
          })
        : _vm.isSelect
        ? _c(
            "select",
            {
              staticClass: "field-input__control",
              style: _vm.controlStyle,
              domProps: { value: _vm.value == null ? "" : _vm.value },
              on: {
                change: function($event) {
                  return _vm.$emit("input", $event.target.value)
                }
              }
            },
            [
              _c("option", { attrs: { value: "", disabled: "" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.field.placeholder ||
                        _vm.field.label ||
                        "Selecciona..."
                    ) +
                    " "
                )
              ]),
              _vm._l(_vm.options, function(opt, i) {
                return _c(
                  "option",
                  { key: i, domProps: { value: opt.value } },
                  [_vm._v(" " + _vm._s(opt.label || opt.value) + " ")]
                )
              })
            ],
            2
          )
        : _c("input", {
            staticClass: "field-input__control",
            style: _vm.controlStyle,
            attrs: {
              type: _vm.htmlType,
              placeholder: _vm.field.placeholder || _vm.field.label
            },
            domProps: { value: _vm.value == null ? "" : _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event.target.value)
              },
              blur: _vm.onBlur
            }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }